import React, { Component } from 'react';
import { connect } from 'react-redux';
import { slice } from 'lodash';
import {
    toggleSortByBoxWeb,
    applySortByBoth
} from './../../../actions/FilterActions';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier'
import { config } from 'aws-sdk';
import configObj from '../../../config'


class SortByFilterMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMoreSortCollapsed: true,
            sortByLable: this.props.sortBy,
            dropdwnActive: false
        }
    }



    onSortApply = (sortOption) => {
        this.setState({
            sortByLable: this.props.trans[sortOption] ? this.props.trans[sortOption] : sortOption
        })
        common.customTracking('Select Sort By filter -' + configObj.sortByArrTracking[sortOption], common.getPageName());
        this.props.applySortByBoth(sortOption);
        this.props.toggleSortByBoxWeb();
        this.toggleDrpDownMobFilter()
    };

    toggleDrpDownMobFilter = (val) => {
        if (this.props.playerRecomendedSelectedKey == configObj.playerRecomendationDefault) {

            if (val == false) {
                this.setState({
                    dropdwnActive: false
                })
            } else {
                this.setState({
                    dropdwnActive: !this.state.dropdwnActive
                })
                if (!this.state.dropdwnActive == true) {
                    let pageName = "";
                    if (window.location.pathname.indexOf("/manage-team")) {
                        pageName = "/uclfantasy/my-team/transfers/"
                    } else {
                        pageName = "/uclfantasy/create-team/"
                    }
                    common.customTracking('Sort By - Filters', pageName);
                }
            }
        } else {

        }


    }
    render() {
        let trans = this.props.trans;
        let sortListToDisplay = this.props.sortByArr;
        const isMoreSortCollapsed = this.state.isMoreSortCollapsed;
        const className = common.makeClasses({
            'si-drpDwn': true,
            'si-active': this.state.dropdwnActive
        })

        const classNameParent = common.makeClasses({
            'si-filter-types': true,
            'si-sorting-filter': true,
            'si-disabled-filter': this.props.playerRecomendedSelectedKey == configObj.playerRecomendationDefault ? false : true
        })

        const selectedClass = common.makeClasses({
            "si-drpDwn__value": true,
            "si-flexBox": true,
            "si-selected-option": this.props.sortBy != configObj.defaultSortBy
        })

        return <div className={ classNameParent }>
            <span className="si-title">{ this.props.trans['filterSortBy'] }</span>
            <OutsideNotifier
                handler={ () => this.toggleDrpDownMobFilter(false) }>
                <div className="sorting-wrap si-flexBox">
                    <div className="si-form__control">
                        <div className={ className }>
                            { this.state.dropdwnActive == true ? <div className="si-hidden-ctn" onClick={ (e) => this.toggleDrpDownMobFilter(e, false) }></div> : null }
                            <div className={ selectedClass } onClick={ (e) => { e.stopPropagation(); this.toggleDrpDownMobFilter() } }>
                                <span>{ trans[this.props.sortBy] ? trans[this.props.sortBy] : this.props.sortBy }</span>
                            </div>
                            <div className="si-drpDwn__list">

                                {/* { this.state.dropdwnActive == true ? <div className="si-hidden-ctn" onClick={ (e) => this.toggleDrpDownMobFilter(e, false) }></div> : null } */ }
                                <ul>
                                    { sortListToDisplay.map((el) => {
                                        const className = common.makeClasses({
                                            'si-active': el === this.props.sortBy
                                        });
                                        return <li className={ className } key={ el }
                                            onClick={ () => this.onSortApply(el) }>{ trans[el] ? trans[el] : el }</li>
                                    }) }
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </OutsideNotifier>
        </div>

    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        sortByArr: state.formationData.sortByArr,
        isSortByOpenForWeb: state.formationData.isSortByOpenForWeb,
        sortBy: state.formationData.playerFilters.sortBy,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleSortByBoxWeb: () => dispatch(toggleSortByBoxWeb()),
        applySortByBoth: (sortOption) => dispatch(applySortByBoth(sortOption)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SortByFilterMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/SortByFilterMobile.js